/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Toast_Reingest_All_Unmodified_DescInputs */

const es_settings_files_toast_reingest_all_unmodified_desc = /** @type {(inputs: Settings_Files_Toast_Reingest_All_Unmodified_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los archivos ya estaban actualizados.`)
};

const en_settings_files_toast_reingest_all_unmodified_desc = /** @type {(inputs: Settings_Files_Toast_Reingest_All_Unmodified_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All files were already up to date.`)
};

/**
* | output |
* | --- |
* | "All files were already up to date." |
*
* @param {Settings_Files_Toast_Reingest_All_Unmodified_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_toast_reingest_all_unmodified_desc = /** @type {((inputs?: Settings_Files_Toast_Reingest_All_Unmodified_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Toast_Reingest_All_Unmodified_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_toast_reingest_all_unmodified_desc(inputs)
	return en_settings_files_toast_reingest_all_unmodified_desc(inputs)
});
export { settings_files_toast_reingest_all_unmodified_desc as "settings.files.toast.reingest_all_unmodified_desc" }